export default __webpack_public_path__ + "static/ambiance-73378a1ef2af81c89d956c2c7bb96ae0.wav";